// extracted by mini-css-extract-plugin
export default {"borderedLink":"BorderedLink_borderedLink__Az3bS","borderedLink_patients":"BorderedLink_borderedLink_patients__rAYCB","borderedLink__arrow":"BorderedLink_borderedLink__arrow__-dLH7"};